import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "flex flex-col flex-1 h-full bg-white"
};
const _hoisted_2 = {
  class: "flex justify-between items-center py-5 px-4 sticky top-0 z-10 bg-white border-b border-gray-200"
};
const _hoisted_3 = {
  class: "flex justify-end"
};
const _hoisted_4 = {
  class: "overflow-y-auto flex-1 h-full"
};
const _hoisted_5 = {
  class: "p-4"
};
const _hoisted_6 = {
  class: "grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-6"
};
const _hoisted_7 = {
  class: "md:col-span-3"
};
const _hoisted_8 = {
  class: "md:col-span-1"
};
const _hoisted_9 = {
  class: "p-4"
};
const _hoisted_10 = {
  class: "grid grid-cols-1 gap-x-2 gap-y-6 mt-6 md:grid-cols-2"
};
const _hoisted_11 = {
  class: "md:col-span-1"
};
const _hoisted_12 = {
  class: "grid grid-cols-1 gap-x-2 gap-y-6 mt-6 md:grid-cols-10"
};
const _hoisted_13 = {
  class: "md:col-span-1"
};
const _hoisted_14 = {
  class: "md:col-span-3"
};
const _hoisted_15 = {
  class: "md:col-span-2"
};
const _hoisted_16 = {
  class: "md:col-span-3"
};
const _hoisted_17 = {
  class: "md:col-span-1"
};
const _hoisted_18 = {
  class: "p-4"
};
const _hoisted_19 = {
  class: "grid grid-cols-1 gap-x-2 gap-y-6 mt-6 md:grid-cols-2"
};
const _hoisted_20 = {
  class: "md:col-span-1"
};
const _hoisted_21 = {
  class: "md:col-span-1"
};
const _hoisted_22 = {
  class: "grid grid-cols-1 gap-x-2 gap-y-6 mt-6 md:grid-cols-2"
};
const _hoisted_23 = {
  class: "md:col-span-1"
};
const _hoisted_24 = {
  class: "md:col-span-1"
};
const _hoisted_25 = {
  class: "grid grid-cols-1 gap-x-2 gap-y-6 mt-6 md:grid-cols-2"
};
const _hoisted_26 = {
  class: "md:col-span-1"
};
const _hoisted_27 = {
  class: "md:col-span-1"
};
const _hoisted_28 = {
  class: "p-4"
};
const _hoisted_29 = {
  class: "mt-6 ml-4"
};
const _hoisted_30 = {
  class: "grid grid-cols-1 gap-x-2 gap-y-6 mt-6 md:grid-cols-6"
};
const _hoisted_31 = {
  class: "md:col-span-2"
};
const _hoisted_32 = {
  class: "md:col-span-2"
};
const _hoisted_33 = {
  class: "md:col-span-1"
};
const _hoisted_34 = {
  class: "md:col-span-1"
};
const _hoisted_35 = {
  key: 0,
  class: "p-4"
};
const _hoisted_36 = {
  class: "mt-6 ml-4"
};
const _hoisted_37 = {
  key: 1,
  class: "p-4"
};
const _hoisted_38 = {
  class: "mt-6 ml-4 grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-2"
};
const _hoisted_39 = {
  class: "col-span-1"
};
const _hoisted_40 = {
  class: "col-span-1"
};
const _hoisted_41 = {
  class: "col-span-1"
};
const _hoisted_42 = {
  key: 2,
  class: "p-4"
};
const _hoisted_43 = {
  class: "mt-6 ml-4 grid grid-cols-1 gap-x-2 gap-y-6 md:grid-cols-2"
};
const _hoisted_44 = {
  class: "m-2 text-xs text-gray-400"
};
const _hoisted_45 = {
  key: 2
};
const _hoisted_46 = {
  class: "flex flex-row px-4 w-full"
};
const _hoisted_47 = {
  class: "flex-4 grid grid-cols-2 gap-4 w-full",
  "data-cy": "client-detail"
};
const _hoisted_48 = {
  class: "text-base leading-loose space-y-1.5 w-full"
};
const _hoisted_49 = {
  class: "text-sm"
};
const _hoisted_50 = {
  class: "text-sm"
};
const _hoisted_51 = {
  class: "text-sm"
};
const _hoisted_52 = {
  class: "text-sm"
};
const _hoisted_53 = {
  class: "text-sm"
};
const _hoisted_54 = {
  class: "text-sm"
};
const _hoisted_55 = {
  class: "text-sm"
};
const _hoisted_56 = {
  class: "text-sm"
};
const _hoisted_57 = {
  class: "text-sm"
};
const _hoisted_58 = {
  class: "text-base leading-loose space-y-1.5 w-full"
};
const _hoisted_59 = {
  class: "text-sm"
};
const _hoisted_60 = {
  class: "text-sm"
};
const _hoisted_61 = {
  class: "text-sm"
};
const _hoisted_62 = {
  class: "text-sm"
};
const _hoisted_63 = {
  class: "text-sm"
};
const _hoisted_64 = {
  key: 0,
  class: "text-sm"
};
const _hoisted_65 = ["href"];
const _hoisted_66 = {
  key: 1,
  class: "text-sm"
};
const _hoisted_67 = {
  key: 0,
  class: "text-sm"
};
const _hoisted_68 = ["href"];
const _hoisted_69 = {
  key: 1,
  class: "text-sm"
};
const _hoisted_70 = {
  class: "text-sm"
};
const _hoisted_71 = {
  class: "text-sm"
};
const _hoisted_72 = {
  class: "text-sm"
};
const _hoisted_73 = {
  class: "text-sm"
};
const _hoisted_74 = {
  class: "flex-1 text-right no-print px-5"
};
const _hoisted_75 = {
  class: "px-6 py-4 pb-20"
};
const _hoisted_76 = {
  key: 0
};
const _hoisted_77 = {
  class: "mt-2 print:visible invisible h-0 print:h-full whitespace-pre-wrap"
};
const _hoisted_78 = {
  class: "mt-2 print:invisible print:h-0"
};
const _hoisted_79 = {
  key: 1,
  class: "text-base leading-loose space-y-1.5 w-full"
};
const _hoisted_80 = {
  class: "text-sm"
};
const _hoisted_81 = {
  class: "text-sm"
};
const _hoisted_82 = {
  key: 0
};
const _hoisted_83 = {
  class: "text-sm"
};
const _hoisted_84 = {
  key: 1
};
const _hoisted_85 = {
  class: "text-sm"
};
const _hoisted_86 = {
  key: 2,
  class: "text-base leading-loose space-y-1.5 w-full"
};
const _hoisted_87 = {
  class: "m-2 text-xs text-gray-600"
};
const _hoisted_88 = {
  class: "text-sm"
};
const _hoisted_89 = {
  key: 3,
  class: "flex-1 text-right no-print"
};
import { ref, reactive, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import useClientMatterStore from '@/services/useClientMatterStore';
import ClientService from '@/services/ClientService';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { isValidEmail } from '@/services/utils';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlTextarea from '@/components/LlTextarea.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import LlSelect from '@/components/LlSelect.vue';
export default {
  __name: 'ClientInfo',
  props: {
    stateParams: {
      type: Object,
      required: false
    },
    rootScope: {
      type: Object,
      required: false
    },
    alerts: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const props = __props;

    // Pinia stores
    const meStore = useMeStore();
    const {
      me
    } = storeToRefs(meStore);
    const clientMatterStore = useClientMatterStore();
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();

    // Refs
    const formRef = ref(null);
    const originationDialogRef = ref(null);

    // UI state
    const uiState = reactive({
      initialLoading: true,
      isEditing: false,
      isEditingNotes: false,
      saving: false
    });

    // Client data (populated from parent module's client)
    const client = reactive({
      id: null,
      name: '',
      notes: '',
      reference: '',
      customName: '',
      createdBy: '',
      contact: {
        companyName: '',
        title: '',
        first: '',
        middle: '',
        last: '',
        suffix: '',
        email: '',
        cc: '',
        phone: '',
        cell: '',
        fax: '',
        other: '',
        customName: '',
        address: {
          address: '',
          city: '',
          state: '',
          zip: '',
          country: ''
        }
      },
      billing: {},
      originationStepDownDate: null
    });

    // Form state for editing (clone of client)
    const formState = reactive({
      name: '',
      notes: '',
      reference: '',
      contact: {
        companyName: '',
        title: '',
        first: '',
        middle: '',
        last: '',
        suffix: '',
        email: '',
        cc: '',
        phone: '',
        cell: '',
        fax: '',
        other: '',
        customName: '',
        address: {
          address: '',
          city: '',
          state: '',
          zip: '',
          country: ''
        }
      },
      billing: {}
    });

    // Custom fields
    const customFields = ref([]);
    const editCustomFields = ref([]);

    // Validation state
    const emailValidation = reactive({
      hasMultipleEmails: false,
      hasInvalidEmail: false,
      errorMessage: ''
    });
    const ccEmailValidation = reactive({
      hasInvalidEmail: false,
      errorMessage: ''
    });

    // Origination step-down options
    const originationStepDownOptions = [{
      id: false,
      label: 'Enable'
    }, {
      id: true,
      label: 'Disable'
    }];

    // Original notes for undo
    let originalNotes = '';

    // Snapshot of persisted origination fields at edit start (for dirty detection)
    let originalOriginationSnapshot = null;

    // Route change listener cleanup
    let deactivateRouteChange = null;

    // Computed
    const showOriginationSettings = computed(() => {
      return me.value.company?.settings?.report?.originationStepDownPeriodInMonths;
    });
    const isInvalidStepDownPeriod = computed(() => {
      const value = formState.billing?.originationStepDownPeriodInMonths;
      if (value == null || value === '') return false;
      const num = Number(value);
      return isNaN(num) || num < 1;
    });
    const isFormValid = computed(() => {
      if (!formState.name) return false;
      if (emailValidation.hasMultipleEmails || emailValidation.hasInvalidEmail) return false;
      if (ccEmailValidation.hasInvalidEmail) return false;
      if (isInvalidStepDownPeriod.value) return false;
      return true;
    });

    // Lifecycle
    onMounted(async () => {
      try {
        await meStore.getMe();
        await loadClientData();
        await loadCustomFields();

        // Watch for route changes to warn about unsaved notes
        if (props.rootScope) {
          deactivateRouteChange = props.rootScope.$on('$stateChangeStart', event => {
            if (uiState.isEditingNotes) {
              if (props.alerts) {
                props.alerts.warning('You have unsaved changes. Click save or cancel at the bottom of the form');
              }
              event.preventDefault();
            }
          });
        }
      } catch (error) {
        handleError(error);
      } finally {
        uiState.initialLoading = false;
      }
    });

    // Guard against stale component remounting: if clientId changes (e.g., during
    // a rapid Client A → B transition with Vue↔Angular bridge collision), reload data.
    watch(() => props.stateParams?.id, async (newClientId, oldClientId) => {
      if (newClientId && newClientId !== oldClientId && !uiState.initialLoading) {
        try {
          uiState.initialLoading = true;
          await loadClientData();
          await loadCustomFields();
        } catch (error) {
          handleError(error);
        } finally {
          uiState.initialLoading = false;
        }
      }
    }, {
      immediate: false
    });
    onBeforeUnmount(() => {
      if (deactivateRouteChange) {
        deactivateRouteChange();
      }
    });

    // Methods
    function loadClientData() {
      if (props.stateParams?.id) {
        return loadClientFromApi(props.stateParams.id);
      }
    }
    function isActiveClientRoute(expectedClientId) {
      return String(props.stateParams?.id) === String(expectedClientId);
    }
    async function loadClientFromApi(clientId) {
      try {
        const expectedClientId = clientId;
        const data = await clientMatterStore.getClientById(clientId, true);

        // Ignore stale response if user switched clients while request was in flight.
        if (!isActiveClientRoute(expectedClientId)) {
          return;
        }
        Object.assign(client, {
          id: data.id,
          name: data.name,
          notes: data.notes,
          reference: data.reference,
          customName: data.customName,
          createdBy: data.createdBy,
          contact: data.contact || {},
          billing: data.billing || {},
          originationStepDownDate: data.originationStepDownDate
        });
        // Ensure nested address object exists
        if (!client.contact.address) {
          client.contact.address = {};
        }
        originalNotes = data.notes || '';
      } catch (error) {
        handleError(error);
      }
    }
    async function loadCustomFields() {
      try {
        const requestedClientId = props.stateParams?.id || client.id;
        if (!requestedClientId) return;
        const data = await ClientService.getCustomFields(requestedClientId);

        // Ignore stale response if user switched clients while request was in flight.
        if (!isActiveClientRoute(requestedClientId)) {
          return;
        }
        if (data) {
          customFields.value = data.customFields.map(cf => ({
            id: cf.customField.id,
            value: cf.value,
            type: cf.customField.type,
            label: cf.customField.name,
            textValue: cf.textValue,
            numberValue: cf.numberValue,
            enumValueId: cf.enumValue?.id,
            enumOptions: cf.customField.enumOptions || []
          }));
        }
      } catch (error) {
        handleError(error);
      }
    }
    function startEditing() {
      // Clone client data into form state
      Object.assign(formState, {
        name: client.name,
        notes: client.notes,
        reference: client.reference,
        contact: JSON.parse(JSON.stringify(client.contact)),
        billing: JSON.parse(JSON.stringify(client.billing || {}))
      });

      // Clone custom fields for editing
      editCustomFields.value = JSON.parse(JSON.stringify(customFields.value));

      // Setup origination step-down
      if (showOriginationSettings.value) {
        // Snapshot persisted origination fields BEFORE UI mutations
        originalOriginationSnapshot = {
          originationStepDownDisabled: formState.billing.originationStepDownDisabled ?? null,
          originationStepDownPeriodInMonths: formState.billing.originationStepDownPeriodInMonths ?? null,
          originationStepDownStart: formState.billing.originationStepDownStart ? new Date(formState.billing.originationStepDownStart).toISOString().split('T')[0] : null
        };
        formState.billing.originationStepDownStatus = originationStepDownOptions.find(opt => opt.id === formState.billing.originationStepDownDisabled) || originationStepDownOptions[0];
        if (formState.billing.originationStepDownStart) {
          formState.billing.originationStepDownStart = new Date(formState.billing.originationStepDownStart).toISOString().split('T')[0];
        }
        originationStepDownChange();
      }

      // Initial email validation
      validateEmailField(formState.contact.email, emailValidation);
      validateCcEmailField(formState.contact.cc, ccEmailValidation);
      uiState.isEditing = true;
    }
    function cancelEdit() {
      uiState.isEditing = false;
    }
    function originationStepDownChange() {
      formState.billing.originationStepDownDisabled = formState.billing.originationStepDownStatus?.id;
    }
    function validateEmailField(emailValue, validationObj, allowMultiple = false) {
      if (allowMultiple) {
        validationObj.hasInvalidEmail = false;
        validationObj.errorMessage = '';
      } else {
        validationObj.hasMultipleEmails = false;
        validationObj.hasInvalidEmail = false;
        validationObj.errorMessage = '';
      }
      if (!emailValue) return;
      if (!allowMultiple) {
        const hasMultipleEmails = emailValue.includes(',') || emailValue.includes(' ');
        if (hasMultipleEmails) {
          validationObj.hasMultipleEmails = true;
          validationObj.errorMessage = 'Only one address is allowed in the To field. Please add additional addresses in the CC field.';
          return;
        }
        if (!isValidEmail(emailValue.trim())) {
          validationObj.hasInvalidEmail = true;
          validationObj.errorMessage = 'Email is not valid.';
        }
      } else {
        const emails = emailValue.split(',').map(e => e.trim()).filter(e => e);
        const invalidEmails = emails.filter(e => !isValidEmail(e));
        if (invalidEmails.length > 0) {
          validationObj.hasInvalidEmail = true;
          validationObj.errorMessage = invalidEmails.length === 1 ? `Invalid email address: ${invalidEmails[0]}` : `Invalid email addresses: ${invalidEmails.join(', ')}`;
        }
      }
    }
    function validateCcEmailField(emailValue, validationObj) {
      validateEmailField(emailValue, validationObj, true);
    }
    async function save() {
      if (!formState.name) {
        handleError('A company, contact person, or custom display name must be provided');
        return;
      }

      // Re-validate emails
      validateEmailField(formState.contact.email, emailValidation);
      validateCcEmailField(formState.contact.cc, ccEmailValidation);
      if (emailValidation.hasMultipleEmails) {
        handleError(emailValidation.errorMessage);
        return;
      }
      if (emailValidation.hasInvalidEmail) {
        handleError(emailValidation.errorMessage);
        return;
      }
      if (ccEmailValidation.hasInvalidEmail) {
        handleError(ccEmailValidation.errorMessage);
        return;
      }

      // Build a billing payload clone so formState stays intact if save fails
      let billingPayload = JSON.parse(JSON.stringify(formState.billing));

      // Check if persisted origination fields actually changed
      if (showOriginationSettings.value) {
        const currentOriginationSnapshot = {
          originationStepDownDisabled: formState.billing.originationStepDownDisabled ?? null,
          originationStepDownPeriodInMonths: formState.billing.originationStepDownPeriodInMonths ?? null,
          originationStepDownStart: formState.billing.originationStepDownStart || null
        };
        const originationChanged = JSON.stringify(originalOriginationSnapshot) !== JSON.stringify(currentOriginationSnapshot);
        if (originationChanged) {
          const overwrite = await originationDialogRef.value.open();
          billingPayload.overwriteMatter = overwrite;
        } else {
          // Strip origination fields entirely when unchanged, matching legacy
          // Angular behavior to avoid accidental overwrites/format conversions
          delete billingPayload.originationStepDownDisabled;
          delete billingPayload.originationStepDownPeriodInMonths;
          delete billingPayload.originationStepDownStart;
        }

        // Always strip UI-only field before sending to API
        delete billingPayload.originationStepDownStatus;
      } else {
        // Strip UI-only field even when origination settings not shown
        delete billingPayload.originationStepDownStatus;
      }
      await finishSave(billingPayload);
    }
    async function finishSave(billingPayload) {
      uiState.saving = true;
      try {
        const clientId = client.id || props.stateParams?.id;

        // --- Perform ALL API calls before updating any local state ---

        // 1. Save custom fields (if any)
        let customFieldsResult = null;
        if (editCustomFields.value.length) {
          const cfPayload = editCustomFields.value.map(cf => ({
            id: cf.id,
            enumValueId: cf.enumValueId,
            textValue: cf.textValue,
            numberValue: cf.numberValue
          }));
          customFieldsResult = await ClientService.updateCustomFields(clientId, cfPayload);
        }

        // 2. Save client data
        const updatePayload = {
          name: formState.name,
          notes: formState.notes,
          reference: formState.reference,
          contact: formState.contact,
          billing: billingPayload
        };
        const savedClient = await clientMatterStore.updateClient({
          id: clientId,
          update: updatePayload
        });

        // Defensive: if savedClient is null, the user navigated away before response arrived.
        // Don't update local state with stale data.
        if (!savedClient) {
          return;
        }
        // --- Both API calls succeeded: commit all local state at once ---

        if (customFieldsResult) {
          await loadCustomFields();
        }

        // Use the server response as source of truth for local state
        Object.assign(client, {
          id: savedClient.id,
          name: savedClient.name,
          notes: savedClient.notes,
          reference: savedClient.reference,
          customName: savedClient.customName || '',
          createdBy: savedClient.createdBy,
          contact: savedClient.contact || {},
          billing: savedClient.billing || {},
          originationStepDownDate: savedClient.originationStepDownDate
        });
        if (!client.contact.address) {
          client.contact.address = {};
        }
        originalNotes = savedClient.notes || '';
        handleSuccess('Client details updated!');
        uiState.isEditing = false;
      } catch (error) {
        handleError(error);
      } finally {
        uiState.saving = false;
      }
    }
    function onNameChanged() {
      const contact = formState.contact;
      if (contact.customName) return;
      let usingCompany = false;
      if (contact.companyName) {
        usingCompany = true;
        formState.name = contact.companyName;
      } else {
        formState.name = '';
      }
      if (!usingCompany) {
        if (formState.name) {
          if (contact.last && contact.first) {
            formState.name = [contact.first, contact.middle, contact.last, contact.suffix].filter(Boolean).join(' ');
          } else if (contact.last) {
            formState.name = contact.last;
          } else if (contact.first) {
            formState.name = contact.first;
          }
        } else if (contact.last && contact.first) {
          formState.name = `${contact.last}, ${[contact.first, contact.middle, contact.suffix].filter(Boolean).join(' ')}`;
        } else if (contact.last) {
          formState.name = contact.last;
        } else if (contact.first) {
          formState.name = contact.first;
        }
      }
    }
    function customDisplayNameSet(displayName) {
      formState.contact.customName = displayName;
    }
    function noteEditing() {
      uiState.isEditingNotes = true;
    }
    function cancelNotes() {
      uiState.isEditingNotes = false;
      client.notes = originalNotes;
    }
    async function saveNotes() {
      uiState.saving = true;
      try {
        const clientId = client.id || props.stateParams?.id;
        const savedClient = await clientMatterStore.updateClient({
          id: clientId,
          update: {
            name: client.name,
            notes: client.notes,
            reference: client.reference,
            contact: client.contact,
            billing: client.billing
          }
        });

        // Defensive: if savedClient is null, the user navigated away before response arrived.
        // Don't update local state with stale data.
        if (!savedClient) {
          return;
        }
        client.notes = savedClient.notes;
        originalNotes = savedClient.notes;
        uiState.isEditingNotes = false;
        handleSuccess('Client details updated!');
      } catch (error) {
        handleError(error);
      } finally {
        uiState.saving = false;
      }
    }
    function print() {
      window.print();
    }
    function formatDateDisplay(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      return new Intl.DateTimeFormat('default', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
      }).format(date);
    }
    return (_ctx, _cache) => {
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_container = _resolveComponent("v-container");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_select = _resolveComponent("v-select");
      const _component_v_form = _resolveComponent("v-form");
      return uiState.initialLoading ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "pa-4"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_skeleton_loader, {
          type: "heading, text@3, divider, text@6, divider, text@4"
        })]),
        _: 1
      })) : uiState.isEditing ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[28] || (_cache[28] = _createElementVNode("div", {
        class: "space-y-1 md:px-6"
      }, [_createElementVNode("div", {
        class: "text-lg font-medium leading-6 text-gray-900"
      }, " Client Information "), _createElementVNode("p", {
        class: "max-w-2xl text-sm text-gray-500"
      }, [_createTextVNode(" This is shared between all matters for this client. To override contact information for specific matters go to the "), _createElementVNode("span", {
        class: "font-semibold"
      }, "QuickBooks"), _createTextVNode(" tab under the matter. ")])], -1)), _createElementVNode("div", _hoisted_3, [_withDirectives(_createVNode(LlSecondaryButton, {
        onClick: cancelEdit,
        class: "py-2 px-4"
      }, {
        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }, 512), [[_vShow, !uiState.saving]]), _withDirectives(_createVNode(LlSecondaryButton, {
        color: "primary",
        disabled: uiState.saving || !isFormValid.value,
        onClick: save,
        class: "ml-3"
      }, {
        default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode(" Update ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), [[_vShow, !uiState.saving]]), _withDirectives(_createVNode(_component_v_progress_circular, {
        indeterminate: "",
        size: "24",
        width: "2"
      }, null, 512), [[_vShow, uiState.saving]])])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_v_form, {
        ref_key: "formRef",
        ref: formRef,
        class: "flex flex-col flex-1"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(LlTextField, {
          modelValue: formState.contact.companyName,
          "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => formState.contact.companyName = $event), onNameChanged],
          label: "Company"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_createVNode(LlTextField, {
          modelValue: formState.reference,
          "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => formState.reference = $event), onNameChanged],
          label: "Client ID"
        }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_9, [_cache[29] || (_cache[29] = _createElementVNode("h3", {
          class: "text-lg font-medium leading-6 text-gray-700"
        }, " Personal Information ", -1)), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(LlTextField, {
          modelValue: formState.name,
          "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => formState.name = $event), customDisplayNameSet],
          label: "Display Name"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(LlTextField, {
          modelValue: formState.contact.title,
          "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => formState.contact.title = $event), onNameChanged],
          label: "Title"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_14, [_createVNode(LlTextField, {
          modelValue: formState.contact.first,
          "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => formState.contact.first = $event), onNameChanged],
          label: "First Name"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_15, [_createVNode(LlTextField, {
          modelValue: formState.contact.middle,
          "onUpdate:modelValue": [_cache[5] || (_cache[5] = $event => formState.contact.middle = $event), onNameChanged],
          label: "Middle Name"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_16, [_createVNode(LlTextField, {
          modelValue: formState.contact.last,
          "onUpdate:modelValue": [_cache[6] || (_cache[6] = $event => formState.contact.last = $event), onNameChanged],
          label: "Last Name"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_17, [_createVNode(LlTextField, {
          modelValue: formState.contact.suffix,
          "onUpdate:modelValue": [_cache[7] || (_cache[7] = $event => formState.contact.suffix = $event), onNameChanged],
          label: "Suffix"
        }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_18, [_cache[30] || (_cache[30] = _createElementVNode("h3", {
          class: "text-lg font-medium leading-6 text-gray-700"
        }, "Contact", -1)), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(LlTextField, {
          modelValue: formState.contact.email,
          "onUpdate:modelValue": [_cache[8] || (_cache[8] = $event => formState.contact.email = $event), _cache[9] || (_cache[9] = $event => validateEmailField(formState.contact.email, emailValidation))],
          label: "Email",
          "error-messages": emailValidation.errorMessage ? [emailValidation.errorMessage] : []
        }, null, 8, ["modelValue", "error-messages"])]), _createElementVNode("div", _hoisted_21, [_createVNode(LlTextField, {
          modelValue: formState.contact.cc,
          "onUpdate:modelValue": [_cache[10] || (_cache[10] = $event => formState.contact.cc = $event), _cache[11] || (_cache[11] = $event => validateCcEmailField(formState.contact.cc, ccEmailValidation))],
          label: "Email CC",
          "error-messages": ccEmailValidation.errorMessage ? [ccEmailValidation.errorMessage] : []
        }, null, 8, ["modelValue", "error-messages"])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(LlTextField, {
          modelValue: formState.contact.phone,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => formState.contact.phone = $event),
          label: "Phone"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_24, [_createVNode(LlTextField, {
          modelValue: formState.contact.cell,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formState.contact.cell = $event),
          label: "Cell"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(LlTextField, {
          modelValue: formState.contact.fax,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => formState.contact.fax = $event),
          label: "Fax"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_27, [_createVNode(LlTextField, {
          modelValue: formState.contact.other,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => formState.contact.other = $event),
          label: "Other Phone"
        }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(LlTextarea, {
          modelValue: formState.contact.address.address,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => formState.contact.address.address = $event),
          label: "Address",
          rows: "4"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createVNode(LlTextField, {
          modelValue: formState.contact.address.city,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => formState.contact.address.city = $event),
          label: "City / Town"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_32, [_createVNode(LlTextField, {
          modelValue: formState.contact.address.state,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => formState.contact.address.state = $event),
          label: "State / Province / Region"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_33, [_createVNode(LlTextField, {
          modelValue: formState.contact.address.zip,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => formState.contact.address.zip = $event),
          label: "ZIP"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_34, [_createVNode(LlTextField, {
          modelValue: formState.contact.address.country,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => formState.contact.address.country = $event),
          label: "Country"
        }, null, 8, ["modelValue"])])])]), _unref(me).permissions?.matters?.clientNotes ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_cache[31] || (_cache[31] = _createElementVNode("h3", {
          class: "text-lg font-medium leading-6 text-gray-700"
        }, "Notes", -1)), _createElementVNode("div", _hoisted_36, [_createVNode(LlTextarea, {
          modelValue: formState.notes,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => formState.notes = $event),
          rows: "4"
        }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), showOriginationSettings.value ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_cache[32] || (_cache[32] = _createElementVNode("h3", {
          class: "text-lg font-medium leading-6 text-gray-700"
        }, " Origination Settings ", -1)), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createVNode(_component_v_select, {
          modelValue: formState.billing.originationStepDownStatus,
          "onUpdate:modelValue": [_cache[22] || (_cache[22] = $event => formState.billing.originationStepDownStatus = $event), originationStepDownChange],
          items: originationStepDownOptions,
          "item-title": "label",
          "item-value": "id",
          label: "Step-down Status",
          "return-object": ""
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_40, [_createVNode(LlTextField, {
          modelValue: formState.billing.originationStepDownPeriodInMonths,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => formState.billing.originationStepDownPeriodInMonths = $event),
          modelModifiers: {
            number: true
          },
          label: "Step-down Duration",
          type: "number",
          disabled: formState.billing.originationStepDownDisabled,
          "error-messages": isInvalidStepDownPeriod.value ? ['Step-down Duration must be a positive number'] : [],
          suffix: "Months"
        }, null, 8, ["modelValue", "disabled", "error-messages"])]), _createElementVNode("div", _hoisted_41, [_createVNode(LlTextField, {
          modelValue: formState.billing.originationStepDownStart,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => formState.billing.originationStepDownStart = $event),
          label: "Step-down Start Date",
          type: "date"
        }, null, 8, ["modelValue"])])])])) : _createCommentVNode("", true), editCustomFields.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_cache[33] || (_cache[33] = _createElementVNode("h3", {
          class: "text-lg font-medium leading-6 text-gray-700"
        }, " Custom Field ", -1)), _createElementVNode("div", _hoisted_43, [_createElementVNode("table", null, [_createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editCustomFields.value, customField => {
          return _openBlock(), _createElementBlock("tr", {
            key: customField.id
          }, [_createElementVNode("td", null, [_createElementVNode("div", _hoisted_44, _toDisplayString(customField.label), 1)]), _createElementVNode("td", null, [customField.type === 'enum' ? (_openBlock(), _createBlock(LlSelect, {
            key: 0,
            modelValue: customField.enumValueId,
            "onUpdate:modelValue": $event => customField.enumValueId = $event,
            items: customField.enumOptions,
            "item-title": "label",
            "item-value": "id",
            "return-object": false,
            clearable: "",
            placeholder: "Select...",
            "hide-details": ""
          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])) : customField.type === 'number' ? (_openBlock(), _createBlock(LlTextField, {
            key: 1,
            modelValue: customField.numberValue,
            "onUpdate:modelValue": $event => customField.numberValue = $event,
            modelModifiers: {
              number: true
            },
            type: "number",
            step: "any",
            "hide-details": ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])) : (_openBlock(), _createBlock(LlTextField, {
            key: 2,
            modelValue: customField.textValue,
            "onUpdate:modelValue": $event => customField.textValue = $event,
            "hide-details": ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"]))])]);
        }), 128))])])])])) : _createCommentVNode("", true)]),
        _: 1
      }, 512)]), _createVNode(LlConfirmationDialog, {
        ref_key: "originationDialogRef",
        ref: originationDialogRef,
        title: "Origination Step-down",
        message: `Do you want to apply your Origination Step-down changes to this Client's ${_unref(me).terms?.Matter || 'Matter'}s?`,
        "confirm-text": `Save Changes and Apply to ${_unref(me).terms?.Matter || 'Matter'}s`,
        "toggle-text": "Cancel",
        "confirm-color": "primary"
      }, null, 8, ["message", "confirm-text"])])) : (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_cache[43] || (_cache[43] = _createElementVNode("div", {
        class: "text-sm font-semibold"
      }, "Internal", -1)), _createElementVNode("table", null, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[34] || (_cache[34] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Company")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_49, _toDisplayString(client.contact?.companyName), 1)])]), _createElementVNode("tr", null, [_cache[35] || (_cache[35] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Client Id")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_50, _toDisplayString(client.reference || '-'), 1)])]), _createElementVNode("tr", null, [_cache[36] || (_cache[36] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Display Name")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_51, _toDisplayString(client.customName || client.name), 1)])]), _createElementVNode("tr", null, [_cache[37] || (_cache[37] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Created By")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_52, _toDisplayString(client.createdBy || '-'), 1)])])])]), _cache[44] || (_cache[44] = _createElementVNode("div", {
        class: "text-sm font-semibold pt-2"
      }, "Invoicing Address", -1)), _createElementVNode("table", null, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[38] || (_cache[38] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Address")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_53, _toDisplayString(client.contact?.address?.address || '-'), 1)])]), _createElementVNode("tr", null, [_cache[39] || (_cache[39] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "City")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_54, _toDisplayString(client.contact?.address?.city || '-'), 1)])]), _createElementVNode("tr", null, [_cache[40] || (_cache[40] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Country")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_55, _toDisplayString(client.contact?.address?.country || '-'), 1)])]), _createElementVNode("tr", null, [_cache[41] || (_cache[41] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "State")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_56, _toDisplayString(client.contact?.address?.state || '-'), 1)])]), _createElementVNode("tr", null, [_cache[42] || (_cache[42] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Zip")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_57, _toDisplayString(client.contact?.address?.zip || '-'), 1)])])])])]), _createElementVNode("div", _hoisted_58, [_cache[56] || (_cache[56] = _createElementVNode("div", {
        class: "text-sm font-semibold"
      }, "Contact", -1)), _createElementVNode("table", null, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[45] || (_cache[45] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Title")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_59, _toDisplayString(client.contact?.title || '-'), 1)])]), _createElementVNode("tr", null, [_cache[46] || (_cache[46] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "First Name")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_60, _toDisplayString(client.contact?.first || '-'), 1)])]), _createElementVNode("tr", null, [_cache[47] || (_cache[47] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Middle Name")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_61, _toDisplayString(client.contact?.middle || '-'), 1)])]), _createElementVNode("tr", null, [_cache[48] || (_cache[48] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Last Name")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_62, _toDisplayString(client.contact?.last || '-'), 1)])]), _createElementVNode("tr", null, [_cache[49] || (_cache[49] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Suffix")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_63, _toDisplayString(client.contact?.suffix || '-'), 1)])]), _createElementVNode("tr", null, [_cache[50] || (_cache[50] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Email")], -1)), _createElementVNode("td", null, [client.contact?.email ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createElementVNode("a", {
        href: `mailto:${client.contact.email}`
      }, _toDisplayString(client.contact.email), 9, _hoisted_65)])) : (_openBlock(), _createElementBlock("div", _hoisted_66, "-"))])]), _createElementVNode("tr", null, [_cache[51] || (_cache[51] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Email CC")], -1)), _createElementVNode("td", null, [client.contact?.cc ? (_openBlock(), _createElementBlock("div", _hoisted_67, [_createElementVNode("a", {
        href: `mailto:${client.contact.cc}`
      }, _toDisplayString(client.contact.cc), 9, _hoisted_68)])) : (_openBlock(), _createElementBlock("div", _hoisted_69, "-"))])]), _createElementVNode("tr", null, [_cache[52] || (_cache[52] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Fax")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_70, _toDisplayString(client.contact?.fax || '-'), 1)])]), _createElementVNode("tr", null, [_cache[53] || (_cache[53] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Phone")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_71, _toDisplayString(client.contact?.phone || '-'), 1)])]), _createElementVNode("tr", null, [_cache[54] || (_cache[54] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Cell")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_72, _toDisplayString(client.contact?.cell || '-'), 1)])]), _createElementVNode("tr", null, [_cache[55] || (_cache[55] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "mr-2 text-xs text-gray-400"
      }, "Other")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_73, _toDisplayString(client.contact?.other || '-'), 1)])])])])])]), _createElementVNode("div", _hoisted_74, [_createVNode(LlSecondaryButton, {
        onClick: print,
        class: "block mb-8 ml-auto"
      }, {
        default: _withCtx(() => [...(_cache[57] || (_cache[57] = [_createTextVNode(" Print ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        onClick: startEditing,
        class: "block mb-8 ml-auto"
      }, {
        default: _withCtx(() => [...(_cache[58] || (_cache[58] = [_createTextVNode(" Edit ", -1)]))]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_75, [_unref(me).permissions?.matters?.clientNotes ? (_openBlock(), _createElementBlock("form", _hoisted_76, [_cache[59] || (_cache[59] = _createElementVNode("h3", {
        class: "text-sm px-2 font-semibold"
      }, "Notes", -1)), _createElementVNode("div", _hoisted_77, _toDisplayString(client.notes), 1), _createElementVNode("div", _hoisted_78, [_createVNode(LlTextarea, {
        modelValue: client.notes,
        "onUpdate:modelValue": [_cache[25] || (_cache[25] = $event => client.notes = $event), noteEditing],
        rows: "4"
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), showOriginationSettings.value ? (_openBlock(), _createElementBlock("div", _hoisted_79, [_cache[64] || (_cache[64] = _createElementVNode("h3", {
        class: "text-lg font-bold"
      }, "Origination Settings", -1)), _createElementVNode("table", null, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[60] || (_cache[60] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "my-1 text-xs text-gray-600"
      }, "Step-down Status")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_80, _toDisplayString(client.billing?.originationStepDownDisabled ? 'Disabled' : 'Enabled'), 1)])]), _createElementVNode("tr", null, [_cache[61] || (_cache[61] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "my-1 text-xs text-gray-600"
      }, " Step-down Start Date ")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_81, _toDisplayString(formatDateDisplay(client.billing?.originationStepDownStart)), 1)])]), !client.billing?.originationStepDownDisabled ? (_openBlock(), _createElementBlock("tr", _hoisted_82, [_cache[62] || (_cache[62] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "my-1 text-xs text-gray-600"
      }, "Step-down Duration")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_83, _toDisplayString(client.billing?.originationStepDownPeriodInMonths || '-'), 1)])])) : _createCommentVNode("", true), !client.billing?.originationStepDownDisabled ? (_openBlock(), _createElementBlock("tr", _hoisted_84, [_cache[63] || (_cache[63] = _createElementVNode("td", null, [_createElementVNode("div", {
        class: "my-1 text-xs text-gray-600"
      }, "Step-down End Date")], -1)), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_85, _toDisplayString(formatDateDisplay(client.originationStepDownDate)), 1)])])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), customFields.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_cache[65] || (_cache[65] = _createElementVNode("h3", {
        class: "text-lg px-2 font-bold"
      }, "Custom Field", -1)), _createElementVNode("table", null, [_createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customFields.value, customField => {
        return _openBlock(), _createElementBlock("tr", {
          key: customField.id
        }, [_createElementVNode("td", null, [_createElementVNode("div", _hoisted_87, _toDisplayString(customField.label), 1)]), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_88, _toDisplayString(customField.value != null && customField.value !== '' ? customField.value : '-'), 1)])]);
      }), 128))])])])) : _createCommentVNode("", true), uiState.isEditingNotes ? (_openBlock(), _createElementBlock("div", _hoisted_89, [_createVNode(LlSecondaryButton, {
        onClick: cancelNotes,
        class: "py-2 px-4"
      }, {
        default: _withCtx(() => [...(_cache[66] || (_cache[66] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        color: "primary",
        disabled: uiState.saving,
        class: "ml-3",
        onClick: saveNotes
      }, {
        default: _withCtx(() => [...(_cache[67] || (_cache[67] = [_createTextVNode(" Save ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])) : _createCommentVNode("", true)])]));
    };
  }
};